import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Popup.css'; // Import your CSS for styling

const Popup = ({ onClose }) => {
  const navigate = useNavigate();

  const handleBookNow = () => {
    onClose(); // Close the popup
    navigate('/appointment'); // Redirect to the appointment page
  };

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <button className="close-button" onClick={onClose}>&times;</button>
        <h2>Request Appointment</h2>
        <p>Don't miss out! <br />Schedule your appointment now and we will be in <br />touch with you shortly;</p>
        <p>Or call <b>+91 8827743823</b> between 9 am and 7 pm.</p>
        <button className="book-now-button" onClick={handleBookNow}>Book Now</button>
      </div>
    </div>
  );
};

export default Popup;
